import React from "react";
import {
  LucideTicket,
  LucideTrendingDown,
  LucideReceipt,
  LucideHourglass,
  LucideBookOpen,
  LucideClipboardCheck,
  LucidePhoneCall,
  LucideListChecks,
  LucideCalendarCheck,
  LucideClock,
  LucidePlane,
  LucideCalendarDays,
} from "lucide-react";
import "../features/features-styles.css";

const features = [
  {
    icon: <LucideTicket size={36} />,
    title: "Support Tickets",
    description:
      "View and resolve cases faster. Reduce resolution wait time and manage SLAs efficiently.",
  },
  {
    icon: <LucideTrendingDown size={36} />,
    title: "Expense Tracking",
    description:
      "Monitor your cash flow and expenses in real-time using detailed visual insights.",
  },
  {
    icon: <LucideReceipt size={36} />,
    title: "Invoice Generator",
    description:
      "Generate sleek, branded invoices tailored to your business process.",
  },
  {
    icon: <LucideHourglass size={36} />,
    title: "Scheduling",
    description: "Automate appointments and sync work schedules effortlessly.",
  },
  {
    icon: <LucideBookOpen size={36} />,
    title: "Learning Management",
    description: "Centralize employee training, resources, and upskilling.",
  },
  {
    icon: <LucideClipboardCheck size={36} />,
    title: "Online Assessment",
    description:
      "Conduct smart, gamified staff assessments with timers and analytics.",
  },
  {
    icon: <LucidePhoneCall size={36} />,
    title: "SalesBook",
    description: "Manage leads, contacts, and pipelines all in one place.",
  },
  {
    icon: <LucideListChecks size={36} />,
    title: "Task Manager",
    description:
      "Streamline team tasks with agile boards and productivity tools.",
  },
  {
    icon: <LucideCalendarCheck size={36} />,
    title: "Availability",
    description: "Track and manage real-time employee availability and shifts.",
  },
  {
    icon: <LucideClock size={36} />,
    title: "Timesheet",
    description: "Log hours, breaks, and validate work time based on outcomes.",
  },
  {
    icon: <LucidePlane size={36} />,
    title: "Leave Management",
    description: "Track availability and handle leave requests with ease.",
  },
  {
    icon: <LucideCalendarDays size={36} />,
    title: "Event Management",
    description:
      "Plan and manage internal/external events, attendees, and schedules.",
  },
];

export default function FeaturesSection() {
  return (
    <section className="features-section">
      <div className="container">
        <div className="feature-grid">
          {features.map(({ icon, title, description }, index) => (
            <div className="feature-card" key={index} data-aos="fade-up">
              <div className="feature-icon">{icon}</div>
              <h3 className="feature-title">{title}</h3>
              <p className="feature-description">{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
